<template>
    <q-layout view="hHh lpR fFf">
        <marketing-nav :mobile-nav-open="mobileNav" @toggle-mobile="mobileNav = !mobileNav" />

        <q-page-container>
            <section class="mkt-hero-light mkt-hero-watermark" style="padding:70px 0 40px;">
                <div class="mkt-hero-arcs" aria-hidden="true">
                    <svg class="mkt-hero-arc mkt-hero-arc--bl" viewBox="0 0 600 400" preserveAspectRatio="xMinYMax slice">
                        <defs>
                            <linearGradient id="arcGradBL" x1="0%" y1="100%" x2="100%" y2="0%">
                                <stop offset="0%" stop-color="#4F46E5" stop-opacity="0" />
                                <stop offset="38%" stop-color="#4F46E5" stop-opacity="1" />
                                <stop offset="100%" stop-color="#7C3AED" stop-opacity="0" />
                            </linearGradient>
                        </defs>
                        <g stroke="url(#arcGradBL)" stroke-width="0.7" fill="none">
                            <path d="M -50,350 Q 150,220 380,200 T 700,170" />
                            <path d="M -50,358 Q 155,230 385,210 T 700,180" />
                            <path d="M -50,366 Q 160,240 390,220 T 700,190" />
                            <path d="M -50,374 Q 165,250 395,230 T 700,200" />
                            <path d="M -50,382 Q 170,260 400,240 T 700,210" />
                            <path d="M -50,390 Q 175,270 405,250 T 700,220" />
                            <path d="M -50,398 Q 180,280 410,260 T 700,230" />
                            <path d="M -50,406 Q 185,290 415,270 T 700,240" />
                            <path d="M -50,414 Q 190,300 420,280 T 700,250" />
                            <path d="M -50,422 Q 195,310 425,290 T 700,260" />
                            <path d="M -50,430 Q 200,320 430,300 T 700,270" />
                            <path d="M -50,438 Q 205,330 435,310 T 700,280" />
                        </g>
                    </svg>
                    <svg class="mkt-hero-arc mkt-hero-arc--tr" viewBox="0 0 600 400" preserveAspectRatio="xMinYMax slice">
                        <defs>
                            <linearGradient id="arcGradTR" x1="0%" y1="100%" x2="100%" y2="0%">
                                <stop offset="0%" stop-color="#0EA5E9" stop-opacity="0" />
                                <stop offset="38%" stop-color="#0EA5E9" stop-opacity="1" />
                                <stop offset="100%" stop-color="#4F46E5" stop-opacity="0" />
                            </linearGradient>
                        </defs>
                        <g stroke="url(#arcGradTR)" stroke-width="0.7" fill="none">
                            <path d="M -50,350 Q 150,220 380,200 T 700,170" />
                            <path d="M -50,358 Q 155,230 385,210 T 700,180" />
                            <path d="M -50,366 Q 160,240 390,220 T 700,190" />
                            <path d="M -50,374 Q 165,250 395,230 T 700,200" />
                            <path d="M -50,382 Q 170,260 400,240 T 700,210" />
                            <path d="M -50,390 Q 175,270 405,250 T 700,220" />
                            <path d="M -50,398 Q 180,280 410,260 T 700,230" />
                            <path d="M -50,406 Q 185,290 415,270 T 700,240" />
                            <path d="M -50,414 Q 190,300 420,280 T 700,250" />
                            <path d="M -50,422 Q 195,310 425,290 T 700,260" />
                            <path d="M -50,430 Q 200,320 430,300 T 700,270" />
                            <path d="M -50,438 Q 205,330 435,310 T 700,280" />
                        </g>
                    </svg>
                </div>
                <div class="mkt-hero-watermark-icon mkt-hero-watermark-icon--right" aria-hidden="true">
                    <q-icon name="auto_fix_high" />
                </div>
                <div class="mkt-container text-center" style="position:relative;z-index:1;">
                    <span class="mkt-trust-pill mkt-trust-pill--light q-mb-md" style="display:inline-block;">
                        <q-icon name="auto_awesome" class="mkt-trust-icon" /> Interactive plan finder
                    </span>
                    <h1 class="text-weight-bold q-mt-md q-mb-md" style="font-size:clamp(2rem,4vw,3rem);color:#0F172A;line-height:1.15;">
                        Find the right <span class="text-gradient-indigo">eSign Launchpad</span> plan for you.
                    </h1>
                    <p class="q-mb-md" style="font-size:1.05rem;max-width:620px;margin:0 auto;color:#475569;">
                        Answer five quick questions. We'll match you to the best-fit tier as you go
                        - no signup, no email capture, just honest recommendations based on what you actually need.
                    </p>
                </div>
            </section>

            <section class="mkt-white reveal-fade-up" v-intersection="revealCfg" style="padding:30px 0 80px;">
                <div class="mkt-container">
                    <plan-picker-wizard :max-recommendations="2" />
                    <div class="text-center q-mt-xl">
                        <q-btn flat no-caps color="primary" label="Or see the full plan comparison table"
                               icon-right="arrow_forward" href="/Home/Pricing"
                               style="font-size:0.95rem;font-weight:500;border-radius:8px;" />
                    </div>
                </div>
            </section>

            <footer class="mkt-light" style="padding:40px 0 20px;border-top:1px solid #E2E8F0;">
                <div class="mkt-container">
                    <div class="row justify-between items-center">
                        <div class="row items-center">
                            <img src="/img/logo-nav.webp" alt="eSign Launchpad" width="82" height="22" style="height: 22px; width: auto;" />
                        </div>
                        <div class="row q-gutter-md">
                            <a href="/Home/Features" class="text-no-decoration" style="font-size:0.8rem;color:#475569;">Features</a>
                            <a href="/Home/Pricing" class="text-no-decoration" style="font-size:0.8rem;color:#475569;">Pricing</a>
                            <a href="/Home/Security" class="text-no-decoration" style="font-size:0.8rem;color:#475569;">Security</a>
                            <a href="/news" class="text-no-decoration" style="font-size:0.8rem;color:#475569;">News</a>
                            <a href="/privacy" class="text-no-decoration" style="font-size:0.8rem;color:#475569;">Privacy</a>
                            <a href="/terms" class="text-no-decoration" style="font-size:0.8rem;color:#475569;">Terms</a>
                        </div>
                        <div style="font-size:0.75rem;color:#64748B;">&copy; {{ currentYear }} eSign Launchpad</div>
                    </div>
                </div>
            </footer>
        </q-page-container>
    </q-layout>
</template>

<script>
import PlanPickerWizard from '@components/marketing/PlanPickerWizard.vue';
import MarketingNav from '@components/marketing/MarketingNav.vue';
import { revealMixin } from '@util/reveal.js';

export default {
    name: 'PlanPickerPage',
    mixins: [revealMixin],
    components: { PlanPickerWizard, MarketingNav },
    data() {
        return {
            isAuthenticated: typeof _AUTHENTICATED !== 'undefined' && _AUTHENTICATED === true,
            mobileNav: false,
            currentYear: new Date().getFullYear()
        };
    }
};
</script>

<style scoped>
</style>
